<div class="rs-resume-leadership">
  <button mat-raised-button class="app__button" color="primary" *ngIf="me()" [disabled]="true">{{'leadership.me' | translate}}</button>
  <button mat-raised-button class="app__button" color="primary" *ngIf="!me()" [disabled]="true">{{'leadership.not-me' | translate}}</button>
</div>
